import { Pipe, PipeTransform } from "@angular/core";
import { MemberConstants } from "@app/common/constant/member.constant";
import { AuthUtil } from "@app/common/util/auth.util";

@Pipe({ name: "cusprice" })

export class CustomerPrice implements PipeTransform {

  transform(
    customerPrice?: String | Number | string | number | undefined,
    memberPrice?: String | Number | string | number | undefined,
    agentPrice?: String | Number | string | number | undefined,
    branchOfficePrice?: String | Number | string | number | undefined,
    salesOfficePrice?: String | Number | string | number | undefined,
    generalOfficePrice?: String | Number | string | number | undefined,
    seniorGeneralOfficePrice?: String | Number | string | number | undefined,
    superGeneralOfficePrice?: String | Number | string | number | undefined
  ): String {

    const member = AuthUtil.getLoginedInfo();

    if (member) {
      const rankCd = member?.rankCd ? String(member.rankCd) : '';
      const numRank = rankCd.length >= 4 ? Number(rankCd.substring(2, 4)) : 0;

      if (numRank === MemberConstants.PERMISSION_MEMBERS || numRank === MemberConstants.PERMISSION_AGENCY) {
        return String(memberPrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_BRANCH) {
        return String(agentPrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_BRANCH_OFFICE) {
        return String(branchOfficePrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_SALES_OFFICE) {
        return String(salesOfficePrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_GENERAL_OFFICE) {
        return String(generalOfficePrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_SENIOR_GENERAL_OFFICE) {
        return String(seniorGeneralOfficePrice ?? '');
      } else if (numRank === MemberConstants.PERMISSION_SUPER_GENERAL_OFFICE) {
        return String(superGeneralOfficePrice ?? '');
      }
    }

    return String(customerPrice ?? '');
  }
}